import { getUserData } from "../hooks/auth";
import { Question } from "../type";

const API_URL = process.env.REACT_APP_API_URL;

export async function getQuestion(requestObj: any) {
  const { token } = await getUserData();

  const response = await fetch(`${API_URL}/generate/question`, {
    method: "POST",
    body: JSON.stringify(requestObj),
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((res) => res.json())
    .catch((err) => {
      console.error(err);
      return null;
    });
  if (response) {
    return response.question;
  } else {
    return requestObj.selectedQuestion;
  }
}

export async function getReviewByLLM(
  questions: Question[],
  reviewOptions: string[],
  questionIds: string[]
  // token: string
) {
  const { token } = await getUserData();
  const response = await fetch(`${API_URL}/review`, {
    method: "POST",
    body: JSON.stringify({
      questions,
      reviewOptions,
      targetIds: questionIds,
    }),
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((res) => res.json())
    .catch((err) => {
      console.error(err);
      return null;
    });

  if (response) {
    return response.results;
  } else {
    return [];
  }
}

export async function invokeProcessLog(requestObj: any) {
  const { token } = await getUserData();
  const response = await fetch(`${API_URL}/log`, {
    method: "POST",
    body: JSON.stringify({ data: requestObj }),
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((res) => res.json())
    .catch((err) => {
      console.error(err);
      return null;
    });

  return response;
}
